<ul class="idea-files__list" *ngIf="files?.length; else noFiles">
    <li class="idea-files__item" *ngFor="let f of files">
        <a class="idea-files__name" [href]="fileUrl(f)" target="_blank"
            [title]="f.originalName || f.fileName">{{ f.originalName || f.fileName }}</a>
        <span class="idea-files__date">{{ f.createdAt | date:'dd/MM/yyyy' }}</span>
        <a class="btn card-btn btn-gray-fill text-primary" [href]="fileUrl(f)" target="_blank">
            <svg-icon src="assets/svg/download.svg"></svg-icon>
            {{ 'attachments.download' | translate }}
        </a>
        <button type="button" *ngIf="canManage" class="idea-files__remove" (click)="onRemove(f)">
            {{ 'attachments.removeShort' | translate }}
        </button>
    </li>
</ul>
<ng-template #noFiles>
    <p class="idea-files__empty">{{ 'attachments.empty' | translate }}</p>
</ng-template>

<div class="idea-files__manage" *ngIf="canManage">
    <p class="idea-files__hint">{{ 'attachments.hint' | translate: { max: slots } }}</p>

    <label class="idea-files__select" [class.disabled]="pendingFiles.length >= slots || sending">
        {{ 'attachments.select' | translate }}
        <input type="file" multiple [accept]="accept" (change)="onSelect($event)"
            [disabled]="pendingFiles.length >= slots || sending">
    </label>

    <ul class="idea-files__pending" *ngIf="pendingFiles.length">
        <li *ngFor="let file of pendingFiles; let i = index">
            <span class="idea-files__name" [title]="file.name">{{ file.name }}</span>
            <span class="idea-files__date">{{ formatSize(file.size) }}</span>
            <button type="button" class="idea-files__discard" [disabled]="sending" (click)="onDiscard(i)"
                [attr.aria-label]="'attachments.discard' | translate">X</button>
        </li>
    </ul>

    <button type="button" class="btn btn-primary idea-files__send" *ngIf="pendingFiles.length"
        [disabled]="sending" (click)="onSend()">
        {{ (sending ? 'attachments.sending' : 'attachments.send') | translate }}
    </button>
</div>
